import { Menu, message, Modal, Button, Tooltip, Form, Input } from "antd";
import Sider from "antd/es/layout/Sider";
import React, { useContext, useEffect, useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import {
  BsHexagon,
  BsPatchQuestion,
  BsPower,
  BsWallet,
  BsPeople,
} from "react-icons/bs";
import { IoAnalyticsOutline } from "react-icons/io5";
import { IoSettingsOutline } from "react-icons/io5";
import { Link, useLocation, useNavigate, NavLink } from "react-router-dom";
import login_logo from "../../assets/logo.svg";
// import profile from "../../assets/profile.png";
import profile from "../../assets/profile/animoji-1.png";
import done from "../../assets/ok.png";
import updated from "../../assets/done.png";
import "./sidebar.scss";
import dashboardService from "../../services/dashboardService";
import userService from "../../services/userService";
import { ThemeContext } from "../../context/themeProvider";
import { useDispatch } from "react-redux";
import { setPromotionFalse, setWalletAddressValue } from "../Redux/actions";
import EarnBaaiTokensModal from "../DashboardComponents/EarnBaaiTokensModal";
import { useSelector } from "react-redux";
import { store } from "../Redux/store";
import VerifiedIcon from "./VerifiedIcon";
import setting from "../../assets/logo/setting.png";
import axios from "axios";
import { feedback_key, focii_url } from "../../config";

const ROOT = `side_module`;
export default function Sidebar(props) {
  const navigate = useNavigate();
  const { collapsed, setCollapsed } = props;
  const userDetails = dashboardService.getUserProfile();
  const [activeKey, setActiveKey] = useState("");
  const [profileImageName, setProfileImageName] = useState("");
  const [profileImageSelected, setProfileImageSelected] = useState(false);
  const avatar = [
    "animoji.png",
    "animoji-1.png",
    "animoji-2.png",
    "animoji-3.png",
    "animoji-4.png",
    "animoji-5.png",
    "animoji-6.png",
    "animoji-7.png",
    "animoji-8.png",
    "animoji-9.png",
    "animoji-10.png",
    "animoji-11.png",
  ];
  const { setLoading } = useContext(ThemeContext);
  const dispatch = useDispatch();

  const logout = async () => {
    try {
      setLoading(true);
      const response = await userService.logoutUser();
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message || "Something went worng while logging in"
        );
        navigate("/login");
      } else {
        store.dispatch(setPromotionFalse());

        message.destroy();
        message.success(response?.message || "You have been logged out");
        navigate("/");
        setTimeout(() => {
          userService.removeLocalStorage();
        }, 1000);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      navigate("/login");
      return;
    }
  };

  const updateProfileImage = async () => {
    let dataToSend = {
      profileImage: profileImageName,
    };
    try {
      setLoading(true);
      const response = await dashboardService.updateProfileImage(dataToSend);
      if (response.error) {
        message.destroy();
        message.error(
          response?.error?.message ||
          "Something went worng in getting user details"
        );
      } else {
        // message.success(response?.message)
        props.getDetailsFunc();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      return;
    }
  };

  const handleSubmit = () => {
    if (profileImageName) {
      setProfileImageSelected(true);
      updateProfileImage();
    }
  };

  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (pathname === "/dashboard") setActiveKey("1");
    if (pathname === "/dashboard/referrals") setActiveKey("2");
    if (pathname === "/dashboard/myAnalytics") setActiveKey("3");
    if (pathname === "/dashboard/products") setActiveKey("4");
    if (pathname === "/dashboard/help") setActiveKey("5");

    checkingVerified(userDetails?.userDetails?.email);
  }, [pathname]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    setProfileImageSelected(false);
  };

  const handleMenuItemClick = () => {
    if (window.innerWidth <= 768) {
      // Mobile view threshold
      setCollapsed(true); // Hide the sidebar upon menu item click
    }
  };
  // for earn baai token modal
  const [isTokenModalOpen, setIsTokenModalOpen] = useState(false);
  const showTokenModal = () => {
    setIsTokenModalOpen(true);
  };
  const handleTokenOk = () => {
    setIsTokenModalOpen(false);
  };
  const handleTokenCancel = () => {
    setIsTokenModalOpen(false);
  };
  const promotion = useSelector((state) => state.promotion.isCompleted);

  // modal for reset form
  const [form] = Form.useForm();
  const [viewResetModal, setViewResetModal] = useState(false);
  const [handleSubmitBtn, setHandleSubmitBtn] = useState(false);
  const [handleResetPasswordBtn, setHandleResetPasswordBtn] = useState(false);

  const resetModalShow = () => {
    setViewResetModal(true);
  };

  const hideResetModal = () => {
    setViewResetModal(false);
  };

  const resetPassword = async (values) => {
    let formData = values;
    // console.log(formData)
    // return
    if (formData.email) {
      try {
        setHandleResetPasswordBtn(true);
        const response = await userService.resetPasswordRequest(formData);
        // console.log('verify', verifyUser)
        if (response.error) {
          message.destroy();
          message.error(
            response?.error?.message ||
            "Something went worng in resetting password"
          );
          navigate("/login");
        } else {
          message.destroy();
          message.success(
            response?.message || "Reset password request sent successfully"
          );
        }
        hideResetModal();
      } catch (error) {
        navigate("/login");
        hideResetModal();
      }
    }
    setHandleResetPasswordBtn(false);
    form.resetFields();
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  // checking user verified or not
  const [isVerified, setIsVerified] = useState(false);
  const checkingVerified = async (email) => {
    try {
      const response = await axios.get(
        `${focii_url}/feedback/v1/feedbackExist?email=${email}&type=consumer`,
        {
          headers: {
            "feedback-key": `${feedback_key}`,
          },
        }
      );
      setIsVerified(response.data.data);
    } catch (err) {
      console.log("Not able to fetch feedback data", err.message);
    }
  };
  console.log(isVerified);
  return (
    <Sider
      theme="light"
      className={`${ROOT}__sidebar`}
      breakpoint="lg"
      collapsedWidth="0"
      onBreakpoint={(broken) => {
        console.log(broken);
      }}
      onCollapse={(collapsed, type) => {
        console.log(collapsed, type);
        setCollapsed(collapsed);
      }}
      style={{
        overflow: "auto",
        height: "100vh",
        background: "#fff",
        left: 0,
        top: `${!promotion ? "48px" : 0}`,
        bottom: 0,
        zIndex: !collapsed ? 99 : 9,
        position: !collapsed ? "fixed" : "inherit",
      }}
      collapsed={collapsed}
    >
      <div className="side_fixed">
        <div className="demo-logo-vertical">
          <img alt="user" src={login_logo} />
        </div>
        <div className="profile">
          <div className="profiles" onClick={showModal}>
            <img
              src={
                userDetails?.userDetails?.profileImage && userDetails?.userDetails?.profileImage.includes("avatars") == -1
                  ?
                  require(`../../assets/profile/${userDetails.userDetails.profileImage}`)
                  :
                  profile
              }
              className="image"
            />
            <div className="overlay">
              <a href="#" className="icon" title="User Profile">
                <UploadOutlined />
              </a>
            </div>
          </div>
          <div id="profile-email-section">
            <div className="mt-3 d-flex justify-content-center align-items-start ">
              <button
                className="bg-transparent border-0"
                onClick={() => resetModalShow()}
              >
                {" "}
              </button>
              <div className="dropdown ">
                <button
                  className="dropdown-toggle bg-transparent border-0 reset-dropdown"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <img src={setting} alt="" />{" "}
                </button>
                <ul className="dropdown-menu">
                  <li onClick={() => resetModalShow()}>Reset Password</li>
                </ul>
              </div>
              {isVerified ? (
                <h5>
                  {userDetails?.userDetails?.email}{" "}
                  <Tooltip
                    title="Human Verification Successful"
                  // placement="bottom"
                  >
                    <VerifiedIcon />
                  </Tooltip>
                </h5>
              ) : (
                <>
                  <h5>{userDetails?.userDetails?.email} </h5>
                </>
              )}
            </div>
          </div>

          <Modal
            title=""
            footer={false}
            centered
            open={isModalOpen}
            onCancel={handleOk}
            className={`${ROOT}__upload`}
          >
            <div className={`${ROOT}__select_pic`}>
              {!profileImageSelected ? (
                <>
                  {" "}
                  <p>Select a profile picture</p>
                  <div className="picture">
                    {avatar.map((name) => {
                      return (
                        <span
                          className="emojee"
                          key={name}
                          onClick={() => setProfileImageName(name)}
                        >
                          {" "}
                          <img
                            alt="profile"
                            src={require(`../../assets/profile/${name}`)}
                          />
                          {profileImageName === name && (
                            <img className="mask-image" src={updated} />
                          )}
                        </span>
                      );
                    })}
                  </div>
                  <Button
                    type="primary"
                    size="large"
                    className="mt-4"
                    block
                    onClick={handleSubmit}
                  >
                    Save Profile Photo
                  </Button>
                </>
              ) : (
                <div className="text-center">
                  <img alt="profile" src={done} />
                  <h4 className="mt-3 mb-3">Profile photo updated!</h4>
                  <Button
                    type="primary"
                    size="large"
                    block
                    onClick={() => handleOk()}
                  >
                    Done
                  </Button>
                </div>
              )}
            </div>
          </Modal>
          <Modal
            className="earn-baai-tokens-modal"
            centered
            footer={false}
            open={isTokenModalOpen}
            onOk={handleTokenOk}
            onCancel={handleTokenCancel}
          >
            <EarnBaaiTokensModal handleClose={handleTokenCancel} />
          </Modal>

          <Modal
            className={`${ROOT}__modal_ui`}
            open={viewResetModal}
            title=""
            onOk={() => form.submit()}
            okText="Submit"
            onCancel={() => {
              form.resetFields();
              hideResetModal();
            }}
            okButtonProps={{ disabled: handleResetPasswordBtn }}
          >
            <div className="mb-3 mt-4">
              <h5>
                A reset password link will be sent to your email. Click on the
                link sent, to reset your password.
              </h5>
            </div>
            <Form
              form={form}
              preserve={false}
              name="forgot-password"
              layout="vertical"
              className="login-form"
              initialValues={{
                email: "",
              }}
              onFinish={resetPassword}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    required: true,
                    message: "Please input your email!",
                  },
                ]}
                label="Enter Email"
              >
                <Input placeholder="example@gmail.com" size="large" />
              </Form.Item>
            </Form>
          </Modal>

          {/* <h4>{userDetails?.name}</h4> */}

          {/* {user.isKYCCompleted ? (
          <div className="referral">
            <p>Referral Link:</p>

            <Button
              type="default"
              size="small"
            >
              {' '}
              <Ellipsis length={40}> https://brainalive.ai/referral/id?=283yf82yf9dj29w4y </Ellipsis>
              <CopyOutlined />
            </Button>
          </div>
        ) : (
          <>
            <p>KYC Incomplete, complete your KYC to unlock your unique referral code</p>

            <Button
              size="large"
              block
              type="primary"
            >
              Complete KYC now
            </Button>
          </>
        )} */}
        </div>

        {!promotion && (
          <div>
            <div className="sidebar-earining-add">
              <p>
                Earn more BAAI tokens while watching your favourite YouTube
                Video
              </p>
              <button onClick={showTokenModal}>Start Earning..!</button>
            </div>
          </div>
        )}
        {!promotion && (
          <p
            style={{
              color: "#A0A0A1",
              fontSize: "10px",
              fontFamily: "Nunito",
              paddingLeft: "30px",
              marginTop: "15px",
            }}
          >
            (KYC verification is coming soon)
          </p>
        )}

        <Menu
          className="mt-3 border-0"
          theme="light"
          selectedKeys={activeKey}
          items={[
            {
              eventKey: "1",

              icon: (
                <Link
                  to="/dashboard"
                  onClick={() => handleMenuItemClick()}
                  as={NavLink}
                >
                  <BsWallet style={{ fontSize: "20px" }} />
                </Link>
              ),
              label: "My Dashboard",
              onClick: () =>
                window.screen.availWidth < 1024 && setCollapsed(true),
            },
            {
              eventKey: "2",
              icon: (
                <Link
                  to="/dashboard/referrals"
                  onClick={() => handleMenuItemClick()}
                  as={NavLink}
                >
                  <BsPeople style={{ fontSize: "22px" }} />
                </Link>
              ),
              label: "My Referrals",
              onClick: () =>
                window.screen.availWidth < 1024 && setCollapsed(true),
            },

            {
              eventKey: "3",
              icon: (
                <Link
                  to="/dashboard/myAnalytics"
                  onClick={() => handleMenuItemClick()}
                  as={NavLink}
                >
                  <IoAnalyticsOutline style={{ fontSize: "22px" }} />
                </Link>
              ),
              label: "My Analytics",
              onClick: () =>
                window.screen.availWidth < 1024 && setCollapsed(true),
            },

            {
              eventKey: "4",
              icon: (
                <Link
                  to="/dashboard/products"
                  onClick={() => handleMenuItemClick()}
                  as={NavLink}
                >
                  <BsHexagon style={{ fontSize: "22px" }} />
                </Link>
              ),
              label: "BAAI Products",
              onClick: () =>
                window.screen.availWidth < 1024 && setCollapsed(true),
            },

            {
              eventKey: "5",
              icon: (
                <Link
                  to="/dashboard/help"
                  onClick={() => handleMenuItemClick()}
                  as={NavLink}
                >
                  <BsPatchQuestion style={{ fontSize: "30px" }} />
                </Link>
              ),

              label: " Help & Support",
              onClick: () =>
                window.screen.availWidth < 1024 && setCollapsed(true),
            },

            {
              eventKey: "6",
              icon: <BsPower style={{ fontSize: "22px" }} />,
              label: "Logout",
              onClick: logout,
            },
          ]}
        />
      </div>
    </Sider>
  );
}
